import React from "react";
import Home from "../../Components/Home";
import Facts from "../../Components/Facts";
import ArchMasstimings from "../../Components/ArchMasstimings";
import AboutChurch from "../../Components/AboutChurch";
import SubStations from "../../Components/SubStations";
import ParishAdmin from "../../Components/ParishAdmin";
import { Link } from "react-router";

export default function LandingPage() {
  return (
    <div className="landing-page">
      {/* Hero with Cathedral Carousel & Quick Timetable */}
      <Home />

      {/* Parish Statistics / Facts */}
      <Facts />

      {/* Sacred Scripture / Marian Interlude */}
      <section className="py-5" style={{ background: "linear-gradient(135deg, #102544 0%, #1b3a6b 100%)", color: "#ffffff", borderTop: "2px solid #b89547", borderBottom: "2px solid #b89547" }}>
        <div className="container text-center py-3">
          <i className="fas fa-cross text-secondary mb-3" style={{ fontSize: "1.5rem", color: "#d4b86a" }}></i>
          <blockquote
            className="blockquote mb-2"
            style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: "clamp(1.2rem, 2.5vw, 1.75rem)",
              fontStyle: "italic",
              maxWidth: "820px",
              margin: "0 auto",
              lineHeight: 1.5,
              color: "#fbf8f0"
            }}
          >
            &ldquo;My soul magnifies the Lord, and my spirit rejoices in God my Savior; for the Mighty One has done great things for me, and holy is His name.&rdquo;
          </blockquote>
          <figcaption className="blockquote-footer mt-2" style={{ color: "#d2be92", fontSize: "0.9rem" }}>
            Luke 1:46-49 &bull; The Magnificat of the Blessed Virgin Mary
          </figcaption>
        </div>
      </section>

      {/* Architecture & Mass Timings */}
      <ArchMasstimings />

      {/* Cathedral History & Associations */}
      <AboutChurch />

      {/* Substations */}
      <SubStations />

      {/* Pastoral Leadership / Clergy */}
      <ParishAdmin />

      {/* Pilgrimage & Welcome CTA */}
      <section className="py-5" style={{ background: "#f8f6f0", borderTop: "1px solid #ebe5d8" }}>
        <div className="container py-4 text-center">
          <div className="p-4 p-md-5 rounded-4" style={{ background: "#ffffff", border: "1px solid #ebdcb7", boxShadow: "0 6px 24px rgba(27, 58, 107, 0.06)", maxWidth: "900px", margin: "0 auto" }}>
            <span className="badge mb-3" style={{ background: "#f5eedb", color: "#997327", border: "1px solid #ebdcb7", padding: "6px 16px", letterSpacing: "1px", textTransform: "uppercase" }}>
              All Are Welcome
            </span>
            <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)", fontSize: "clamp(1.6rem, 3vw, 2.2rem)", marginBottom: "14px" }}>
              Experience Peace, Prayer &amp; Heritage in Madurai
            </h3>
            <p style={{ color: "var(--cathedral-text-secondary)", maxWidth: "680px", margin: "0 auto 24px auto", lineHeight: 1.7 }}>
              Whether you are attending daily Mass, seeking pastoral guidance, or visiting to admire our historic Romanesque bell towers, St. Mary's Cathedral welcomes you with open arms.
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              <Link to="/contact" className="btn-cathedral-primary">
                <i className="fas fa-map-marker-alt me-2"></i> Plan Your Visit &amp; Directions
              </Link>
              <Link to="/photo-gallery" className="btn-cathedral-outline">
                <i className="fas fa-images me-2"></i> Browse Photo Gallery
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
